<template>
	<tr v-bind:class="{ error }">
		<td>
			<span v-bind:class="{ error: nameError, success: !nameError }">
				{{ patient.name }}
				<label v-if="nameError">{{ nameError }}</label>
			</span>
		</td>
		<td>
			<span v-bind:class="{ error: emailError, success: hasEmail && !emailError }">
				{{ patient.email }}
				<label v-if="emailError">{{ emailError }}</label>
			</span>
		</td>
		<td>
			<span v-bind:class="{ error: phoneError, success: hasPhone && !phoneError }">
				{{ patient.phone }}
				<label v-if="phoneError">{{ phoneError }}</label>
			</span>
		</td>
		<td v-if="patientProfile && activeColumns.provider">
			<span class="success">
				{{ patientProfile.providerName }}
			</span>
		</td>
		<td v-if="patientProfile && activeColumns.profile">
			<span class="success">
				{{ patientProfile.title }}
			</span>
		</td>
		<td>
			<span class="success">
				{{ patientEvent }}
			</span>
		</td>
		<td>
			<span class="success">
				{{ patientEventTime }}
			</span>
		</td>
		<td>
			<i v-bind:class="{
				'el-icon-check': ! error,
				'el-icon-close': error
			}"></i>
		</td>
	</tr>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import format from '@/module/util/format'

export default {
	name: 'add-patient-row',

	props: {
		patient: {
			type: Object
		},
		error: {
			type: Object
		},
		activeColumns: {
			type: Object
		}
	},

	computed: {
		...mapGetters('provider', [
			'getProviderList',
			'getAllProviderProfileList'
		]),
		...mapState('content', {
			eventObj: state => state.data.event
		}),
		nameError() {
			if (this.error) {
				if (this.error.code == 'InvalidName')
					return 'Please enter a first and last name'
				if (this.error.code == 'MissingEmailPhone')
					return 'A valid email or phone number is required'
			}
			return null
		},
		hasEmail() {
			return this.patient.email &&
				   this.patient.email.trim().length > 0
		},
		emailError() {
			if (this.error) {
				if (this.error.code === 'UserExists')
					return 'Email already in use'
			}
			return null
		},
		hasPhone() {
			return this.patient.phone &&
				   this.patient.phone.trim().length > 0
		},
		phoneError() {
			if (this.error) {
				if (this.error.code === 'PhoneInUse')
					return 'Phone already in use'
			}
			return null
		},
		patientProfile() {
			if(this.patient.providerEnroll) {
				const profile = this.getAllProviderProfileList.find((profile) => this.patient.providerEnroll === profile.providerId)
				return profile
			}
			if(this.patient.profile !== '') {
				const profile = this.getAllProviderProfileList.find((profile) => this.patient.profile[0] === profile.id)
				return profile
			}
			return null
		},
		patientEvent() {
			if(this.patient.schedule && Array.isArray(this.patient.schedule) && this.patient.schedule.length > 0 ) {
				const eventId = this.patient.schedule[0].event
				console.log(this.eventObj)
				return this.eventObj[eventId] ? this.eventObj[eventId].name : eventId
			}
			return 'No Event Selected'
		},
		patientEventTime() {
			if(this.patient.schedule && Array.isArray(this.patient.schedule) && this.patient.schedule.length > 0) {
				const timeStamp = this.patient.schedule[0].time
				return this.formatDate(timeStamp)
			}
			return 'No Time Selected'
		}
	},

	mounted() {
	},

	methods: {
		...format
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
